import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Contact from './components/Contact';
import Gallery from './components/Gallery';
import DemoReels from './components/DemoReels';
import Cinematics from './components/Cinematics';

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Contact />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/demo-reels" element={<DemoReels />} />
        <Route path="/cinematics" element={<Cinematics />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
